module.exports = __webpack_public_path__ + "images/avatar-s-20.32972323.jpg";